import { Button, Col, DatePicker, Form, Input, Select } from 'antd'
import {
  OPTIONS_LABEL_POST_WEB,
  OPTIONS_PACKAGE_STATUS,
  OPTIONS_PACKAGE_TYPE,
  OPTIONS_RECRUITMENT,
  OPTIONS_STATUS_POST_WEB,
  OPTIONS_TYPE_REQUEST
} from '../../configData'
import { v4 as uuidv4 } from 'uuid'
import { statusList } from '../PostManagement/configs'
import { removeVietnameseTones } from '../../config-func'
import { debounce } from 'lodash'
const { RangePicker } = DatePicker
const { Option } = Select

const SearchForm = ({ fetchData, handleSearch, setFilters }) => {
  const [form] = Form.useForm()

  const handleReset = debounce(() => {
    setFilters({ currentPage: 1, pageSize: 10, reset: uuidv4() })
    form.resetFields()
    // fetchData()
  }, 300)

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        setFilters((prev) => ({ ...prev, ...allValues }))
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          alignItems: 'center'
        }}
      >
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Họ và tên" name="full_name">
            <Input
              placeholder="Nhập họ và tên"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'full_name',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Số điện thoại" name="phone_number">
            <Input
              placeholder="Nhập số điện thoại"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'phone_number',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Vị trí ứng tuyển" name="position">
          <Input
              placeholder="Nhập vị trí"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'position',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
            {/* <Select style={{ width: '100%' }} placeholder="Chọn vị trí ứng tuyển" 
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase();
              const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
              return optionValue.includes(inputValue);
            }}
            >
              <Option value={''}>Tất cả</Option>
              {OPTIONS_LABEL_POST_WEB?.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select> */}
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Trạng thái" name="status">
            <Select style={{ width: '100%' }} placeholder="Chọn trạng thái" 
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const inputValue = removeVietnameseTones(input).toLowerCase();
              const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
              return optionValue.includes(inputValue);
            }}
            >
              <Option value={''}>Tất cả</Option>
              {OPTIONS_RECRUITMENT?.map((item, idx) => (
                <Option key={idx} value={item.value}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end',
            flex: '1 1 200px',
            minWidth: '200px'
          }}
        >
          <Button onClick={handleReset}>Đặt lại</Button>
          <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }}>
            Tìm kiếm
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default SearchForm
